// Vendor Libraries
import React from 'react';

// Components
import PanelAction from '../core/panel-action';

function ServicesSearchPanelAction(props) {
    return (
        <PanelAction {...{
            hotkey: 's',
            icon: 'search',
            showPanel: false,
            title: 'Search Filters',
            weight: 50,
            ...props,
            }}
        />
    );
}

export default ServicesSearchPanelAction;
